import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditScreenForm from './EditScreenForm'
import ModalHeader from './ModalHeader'
import ScreenLoader from './_load/ScreenLoader'

const EditScreenModal = props => {
  return (
    <ControlledModal width="32rem" disableClickOutside {...props}>
      <PermissionChecker permission={'setupScreen'}>
        <ScreenLoader>
          <ModalHeader />
          <EditScreenForm />
        </ScreenLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditScreenModal
